
const USER_SUCCESS = "USER_SUCCESS";
const USER_CLEAR = "USER_CLEAR";

const initialState = {
    MultiverseUEmail: null,
    MultiverseRole: null,
    MultiverseUserId: null,
    MultiverseUName: null,
    MultiverseCUAccount: null,
    MultiverseTimezone: null,
};

const localdataReducer = (state = initialState, action) => {
    switch (action.type) {
        case USER_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        case USER_CLEAR:
            return { ...initialState };
        default:
            return state;
    }
};

// Action creators
const setUserData = (payload) => ({ type: USER_SUCCESS, payload });
const clearUserData = () => ({ type: USER_CLEAR });

export { setUserData, clearUserData, localdataReducer };
